import { BoardsListSection } from './ui/list/boards-list.section';

export function BoardsPage() {
  return <BoardsListSection />;
}
